<div class="p-5 bg-white-alpha-40 shadow-1 border-round-3xl">
    <div class="text-900 font-bold text-2xl mb-4">{{ block.title }}</div>
    <div class="[&>p]:mb-0 [&>p]:mt-0 line-height-3 text-base"
         [innerHTML]="block.content_limited | safeHTML">
    </div>
</div>
